<template>
  <v-card
    class="progress-deal-item mb-3"
    :class="{ 'progress-deal-item--expired': isExpired }"
    variant="flat"
    rounded="lg"
  >
    <div class="d-flex align-start justify-space-between mb-1 ga-2">
      <div class="text-body-2 font-weight-bold flex-grow-1">
        {{ title }}
      </div>
      <div
        class="text-body-2 font-weight-bold flex-shrink-0 text-no-wrap"
        :class="isExpired ? 'text-medium-emphasis' : 'text-primary'"
      >
        {{ fractionLabel }}
      </div>
    </div>

    <div class="text-caption text-medium-emphasis mb-2">
      {{ subtitleLine }}
    </div>

    <v-progress-linear
      :model-value="barPercent"
      :color="isExpired ? 'grey' : 'primary'"
      :bg-color="isExpired ? 'grey-lighten-3' : 'white'"
      height="6"
      rounded
      rounded-bar
      class="progress-deal-item__bar"
    />
  </v-card>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  redeemed: {
    type: Number,
    default: 0
  },
  total: {
    type: Number,
    default: 0
  },
  entriesLabel: {
    type: String,
    default: 'Entries'
  },
  isExpired: {
    type: Boolean,
    default: false
  }
});

const barPercent = computed(() => {
  if (!props.total) return 0;
  return Math.min(100, (props.redeemed / props.total) * 100);
});

const fractionLabel = computed(
  () => `${props.redeemed} / ${props.total}`
);

const subtitleLine = computed(() => {
  const earned = `${props.redeemed} of ${props.total} ${String(props.entriesLabel || 'entries earned').toLowerCase()}`;
  return earned;
});
</script>
<style scoped lang="scss">
.progress-deal-item {
  padding: 12px;
  background-color: rgba(var(--v-theme-on-surface), 0.038);
}

.progress-deal-item--expired {
  background-color: rgba(var(--v-theme-on-surface), 0.07);
}

.progress-deal-item--expired :deep(.v-card-text),
.progress-deal-item--expired .text-body-2,
.progress-deal-item--expired .text-caption {
  color: rgba(var(--v-theme-on-surface), 0.52) !important;
}

.progress-deal-item__bar :deep(.v-progress-linear__determinate) {
  transition: width 350ms ease;
  border-radius: 999px;
}

.progress-deal-item__bar :deep(.v-progress-linear__background),
.progress-deal-item__bar :deep(.v-progress-linear__buffer) {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 1) !important;
}
</style>
